import { PlusSquare, Trash2 } from "lucide-react";
import { HelpContentContainer } from ".";
import { ModalHeader } from "@/components/Modal/ModalHeader";
import { AppText } from "@/components/Text/AppText";

interface HelpGuideAddRemoveProps {
    onClose: () => void;
}

export const HelpGuideAddRemove = ({ onClose }: HelpGuideAddRemoveProps) => {
    return (
        <div>
            <ModalHeader
                title="Add/Remove Sections"
                onClose={onClose}
            />
            <HelpContentContainer>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    To add a new section, click on the Add Section Icon (
                    <PlusSquare
                        size={16}
                        className="mb-1 inline"
                    />
                    ) at at the top of the screen.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    You will then be prompted to select what section you would
                    like to include in your resume by clicking on the section.
                    Once you have clicked on a section it will automatically be
                    applied to the bottom of your resume.
                </AppText>
                <AppText
                    variant="regular"
                    className="mb-2"
                >
                    To delete a section in your resume, click on the section you
                    would like to remove and use the Bin icon (
                    <Trash2
                        size={16}
                        className="mb-1 inline"
                    />
                    ) from the hovering menu.
                </AppText>
            </HelpContentContainer>
        </div>
    );
};
